import { Action, RequestStatus, UseCaseStateGenerator } from '@lib/plugin-redux-core';
import {
  FIND_FORM_BY_ID_USE_CASE,
  IMPORT_FORM_USE_CASE,
  Section,
  SectionSummaries,
} from '@module/form';
import {
  FindFormByIdUseCaseState,
  FormEditPageState,
  GetAssignmentConfigurationUseCaseState,
} from './form-edit.states';
import {
  AssignmentConfigurations,
  GET_ASSIGNMENT_CONFIGURATIONS_USE_CASE,
} from '@module/assignment';

export const handleStateOfFindFormByIdUseCase: UseCaseStateGenerator<FindFormByIdUseCaseState> = {
  name: FIND_FORM_BY_ID_USE_CASE,
  executing: (state: FormEditPageState): FormEditPageState => {
    return {
      ...state,
      findFormByIdStatus: RequestStatus.EXECUTE,
    };
  },
  success: (state: FormEditPageState, action: Action): FormEditPageState => {
    const sections = action.payload.sections;

    // NOTE: For UI test - headings
    const headings = action.payload.headings;

    let selectedFormItemId: string;
    let selectedSection: Section | null;

    // NOTE: For AI testing - need remove.
    if (sections && sections.length > 0) {
      selectedFormItemId = sections[0].id.toString();
      selectedSection = sections[0];
    } else {
      selectedFormItemId = '';
      selectedSection = null;
    }

    return {
      ...state,
      formResponse: action.payload,
      sections,
      sectionSummaries: SectionSummaries.toSectionSummaries(sections),
      headings,
      selectedFormItemId,
      selectedSection,
      formTotalQuestions: action.payload.totalQuestion ?? action.payload.totalQuestions ?? 0,
      formTotalScore: action.payload.totalScore ?? 0,
      findFormByIdStatus: RequestStatus.SUCCESS,
    };
  },
  error: (state: FormEditPageState, action: Action): FormEditPageState => {
    const { error } = action;

    return {
      ...state,
      error,
      findFormByIdStatus: RequestStatus.ERROR,
    };
  },
  reset: (state: FormEditPageState): FormEditPageState => {
    return {
      ...state,
      findFormByIdStatus: RequestStatus.RESET,
    };
  },
};
const filterConfigs = (data: AssignmentConfigurations): AssignmentConfigurations => {
  const filteredConfigs = {
    ...data,
  } as AssignmentConfigurations;

  return filteredConfigs;
};
export const handleGetAssignmentConfigurationsUseCase: UseCaseStateGenerator<GetAssignmentConfigurationUseCaseState> =
  {
    name: GET_ASSIGNMENT_CONFIGURATIONS_USE_CASE,
    executing: (state: FormEditPageState): FormEditPageState => {
      return { ...state };
    },
    success: (state: FormEditPageState, action: Action): FormEditPageState => {
      const { payload } = action;
      const assignmentDataConfigs = filterConfigs(payload);
      return {
        ...state,
        assignmentConfigsResponse: assignmentDataConfigs,
      };
    },
    error: (state: FormEditPageState, action: Action): FormEditPageState => {
      const { error } = action;
      return { ...state, error: error };
    },
  };

export const handleImportFormUseCase: UseCaseStateGenerator<FormEditPageState> = {
  name: IMPORT_FORM_USE_CASE,
  executing: (state: FormEditPageState): FormEditPageState => {
    return {
      ...state,
      importFormStatus: RequestStatus.EXECUTE,
    };
  },
  success: (state: FormEditPageState): FormEditPageState => {
    return {
      ...state,
      importFormStatus: RequestStatus.SUCCESS,
    };
  },
  error: (state: FormEditPageState): FormEditPageState => {
    return {
      ...state,
      importFormStatus: RequestStatus.ERROR,
    };
  },
  reset: (state: FormEditPageState): FormEditPageState => {
    return {
      ...state,
      importFormStatus: RequestStatus.RESET,
    };
  },
};

export const commonFormHandlers = [
  handleStateOfFindFormByIdUseCase,
  handleGetAssignmentConfigurationsUseCase,
  handleImportFormUseCase,
];
